import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/appointment')({
  validateSearch: (search: { comparingLocations?: boolean; showingProspectList?: boolean }) => {
    return {
      comparingLocations: search.comparingLocations,
      showingProspectList: search.showingProspectList,
    };
  },
});
